import careEn from "@project/lib/locales/sections/care.en";
import programsEn from "@project/lib/locales/sections/programs.en";
import trustEn from "@project/lib/locales/sections/trust.en";
import communityEn from "@project/lib/locales/sections/community.en";
import pagesEn from "@project/lib/locales/sections/pages.en";
import accountEn from "@project/lib/locales/sections/account.en";

export const en = {
  common: {
    siteName: "Jivandhara Old Age Home",
    tagline: "Dignity, Care & Compassion for Every Elder",
    careCompassionCommunity: "Care • Compassion • Community",
    verified: "Verified",
    certified: "12A • 80G Certified",
    browseCauses: "Browse causes",
    register: "Register",
    learnMore: "Learn More",
  },
  brand: {
    title: "Jivandhara",
    subtitle: "Old Age Home",
  },
  nav: {
    home: "Home",
    about: "About",
    donation: "Donate",
    bhojanshala: "Bhojanshala",
    events: "Events",
    gaushala: "Gaushala",
    contact: "Contact",
    more: "More",
  },
  menu: {
    applyAdmission: "Apply for Admission",
    residentCare: "Resident Care",
    elderCareProgram: "Elder Care Program",
    healthcare: "Healthcare",
    gaushala: "Gaushala",
    events: "Events",
    gruhUdhyog: "Gruh Udhyog",
    transparency: "Transparency & Impact",
    tiffinSeva: "Tiffin Seva",
    news: "News",
    committee: "Committee",
    trustees: "Trustees",
    gallery: "Gallery",
    visitorForm: "Visitor Form",
    feedback: "Feedback",
    jainPanchang: "Jain Panchang",
  },
  lang: {
    english: "English",
    gujarati: "ગુજરાતી",
    change: "Change language",
  },
  footer: {
    quickLinks: "Quick Links",
    services: "Services",
    reachUs: "Reach Us",
    rights: "All rights reserved.",
    aboutUs: "About Us",
    residentCare: "Resident Care",
    donateLink: "Donate",
    events: "Donation Events",
    contact: "Contact",
    gaushala: "Gaushala",
    bhojanTithi: "Bhojanshala",
    tiffinSeva: "Tiffin Seva",
    gruhUdhyog: "Gruh Udhyog",
    address: "Jivandhara vruddhashram, Lambha",
    phone: "+91 00000 00000",
    email: "jivandharavrudhashram@gmail.com",
  },
  home: {
    hero: {
      greeting: "Pranam · प्रणाम · પ્રણામ",
      titleLine1: "For Every Ashram Resident Elder",
      titleLine2: "A Loving Home, Every Day",
      sanskrit: "मातृ देवो भव · पितृ देवो भव",
      description:
        "An all-in-one seva platform providing shelter, food, medical care and dignity to elderly residents — built with compassion for the Jain community & beyond.",
      feature1: "Lifetime resident care",
      feature2: "12A & 80G tax benefits",
      feature3: "Trusted by 1000+ donors",
      admissionApplication: "Admission Application",
      admissionInquiry: "Admission Inquiry",
    },
    statsCard: {
      residents: "Residents",
      caredFor: "Cared For",
      yearsOf: "Years of",
      seva: "Seva",
      generous: "Generous",
      donors: "Donors",
      dailyCare: "Daily Care",
      medical: "Medical",
      shelter: "Shelter",
      thisMonth: "This month",
    },
    trust: {
      heading: "Trusted by Families & Communities Across Gujarat & Bharat",
      residentsCared: "Residents Cared",
      generousDonors: "Generous Donors",
      donationsProcessed: "Donations Processed",
      ofTrustedSeva: "Of Trusted Seva",
    },
    admission: {
      badge: "Admission Enquiry",
      heading: "Looking to admit an elder to our home?",
      description:
        "Submit a simple admission application — share applicant, elder and family details. Our team will reach out within 3 working days to guide you through the next steps.",
      feature1: "Free admission enquiry",
      feature2: "Confidential family information",
      feature3: "Personal follow-up call",
      feature4: "Ashram visit & interview",
      applyButton: "Start Admission Inquiry",
      talkButton: "Talk to our team",
      eldersAdmitted: "Elders Admitted",
      howItWorks: "How it works",
      step1: "1. Submit the admission inquiry",
      step2: "2. Initial telephonic review by our team",
      step3: "3. Family meeting & home visit",
      step4: "4. Admission confirmation",
    },
    visitors: {
      badge: "Visitor Connect",
      heading: "Planning a visit or sharing your experience?",
      description:
        "Choose the option that best fits your needs. Register your upcoming visit through the Visitor Inquiry Form or share your experience, appreciation, and suggestions using the Visitor Feedback Form.",
      feature1: "Register your upcoming visit",
      feature2: "Share your visit feedback",
      feature3: "Family visitor details supported",
      feature4: "Help us improve every visit",
      applyButton: "Visitor Forms",
      talkButton: "Talk to our Team",
      visitsLogged: "Visitor",
      howItWorks: "How it works",
      step1: "1. Choose the appropriate visitor form.",
      step2: "2. Complete the required details.",
      step3: "3. Submit your inquiry or feedback.",
      step4: "4. Our team will review and respond if required.",
    },
    visitorChooser: {
      badge: "Visitor Forms",
      title: "How would you like to connect?",
      description:
        "Choose whether you want to share feedback from a past visit, or register an upcoming visit with us.",
      feedbackTitle: "Visitor Feedback Form",
      feedbackDescription:
        "Share your experience, suggestions or appreciation after visiting Jivandhara.",
      feedbackCta: "Open feedback form",
      inquiryTitle: "Visitor Inquiry Form",
      inquiryDescription:
        "Planning a visit? Share visit details, reason for visit and reference information.",
      inquiryCta: "Open inquiry form",
    },
    schemes: {
      eyebrow: "Explore Jivandhara",
      heading: "Discover Our Services",
      description:
        "Learn how Jivandhara serves elders and the community through compassionate care, healthcare, seva, and the preservation of our cultural values.",
      residentCareTitle: "Resident Care",
      residentCareDesc:
        "Explore how we provide a safe, caring, and dignified home where every elder is treated with love, respect, and compassion.",
      residentCareButton: "Explore Care",
      gaushalaTitle: "Vrindavan Gir Gaushala",
      gaushalaDesc:
        "Discover our Gaushala, dedicated to caring for indigenous Gir cows while preserving our rich cultural and spiritual heritage.",
      gaushalaButton: "Visit Gaushala",
      tiffinTitle: "Tiffin Seva",
      tiffinDesc: "Provide warm, home-cooked tiffins to residents in need.",
      tiffinButton: "Register",
      healthcareTitle: "Healthcare",
      healthcareDesc:
        "Learn about our medical facilities, regular health check-ups, physiotherapy, and compassionate healthcare services for every resident.",
      healthcareButton: "View Healthcare",
    },
    glimpses: {
      eyebrow: "Glimpses of Seva",
      heading: "Moments from our home",
      description:
        "Care, companionship and dignity — captured every day at Jivandhara.",
      festivalLabel: "Festival and Celebrations",
      festivalSub: "Sacred festivals and joyful celebrations at Jivandhara",
      gaushalaLabel: "Gaushala",
      gaushalaSub: "Caring for cows at our Vrindavan Gir Gaushala",
      derasarLabel: "Derasar",
      derasarSub: "Daily worship and spiritual serenity at our temple",
      viewGallery: "View Full Gallery",
    },
    testimonials: {
      eyebrow: "Voices of Trust",
      heading: "What our supporters say",
      description:
        "Kind words from donors, families and well-wishers who believe in our seva.",
    },
    pillars: {
      residentCareTitle: "Resident Care",
      residentCareBody:
        "Lifetime shelter, food, daily care and companionship for every resident.",
      medicalTitle: "Medical Support",
      medicalBody:
        "On-call doctors, daily medicines, hospital tie-ups and emergency care.",
      ritualsTitle: "Rituals & Dignity",
      ritualsBody:
        "From birthdays to last rites — every milestone is observed with respect.",
    },
    shloka: {
      sanskrit: "“यत्र वृद्धाः पूज्यन्ते तत्र देवताः रमन्ते।”",
      translation: "Where elders are respected, divinity resides.",
    },
    cta: {
      headingBefore: "Become Part of Our",
      headingHighlight: "Parivaar",
      headingAfter: "",
      description:
        "Atithi Devo Bhava · अतिथि देवो भव — Visit, volunteer, donate or simply share. Every act of kindness multiplies.",
      donateNow: "Donate Now",
      visitUs: "Visit Us",
    },
  },
  care: careEn,
  programs: programsEn,
  trust: trustEn,
  community: communityEn,
  pages: pagesEn,
  account: accountEn,
};

export type TranslationResources = typeof en;
